import React, { SFC, useEffect } from "react";
import {
    Grid,
    Typography,
    Hidden,
    makeStyles,
    Box,
    PropTypes as MuIPropTypes,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import { TextField } from "formik-material-ui";
import { Field } from "formik";
import { Location } from "../../Location";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {getAddress} from "../../../redux/userProfile/userProfile.actions";
import {IParentProfile} from "../../../interfaces";
import {states} from "../../../Constants/locations";

interface Props {
	setFormikValues: any,
	values: IParentProfile,
	isReadyToFetchData: boolean,
}

const useStyles = makeStyles({
    location: {
        height: 40
    },
    formItem: {
        marginBottom: "1em",
    },
});

const Address: SFC<Props> = ({ values, setFormikValues, isReadyToFetchData}: Props) => {
    const classes = useStyles();
    const user = useSelector((state: RootState) => state?.user);
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const textAlignmentAdaptive: MuIPropTypes.Alignment = isMobile ? "center" : "left";

    useEffect(() => {
        if(isReadyToFetchData) {
            dispatch(getAddress(user.userId))
                .then((address) => {
                    setFormikValues(
                        {
                            ...values,
                            address: address?.firstLine || "",
                            state: address?.state || states[0].value,
                            city: address?.city || "",
                            zip: address?.zipCode || "",
                            country: address?.country || "",
                        }
                    );
                });
        }
    }, []);
    return (
        <>
            <Grid container justify="space-between" alignItems="center"
				  className={classes.formItem}>
                <Grid item xs={12} sm={6}>
                    <Box marginBottom="10px">
                        <Typography
                            variant="h5"
                            align={textAlignmentAdaptive}
                        >
							Address
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        component={TextField}
                        name="address"
                        variant="outlined"
                        fullWidth
                        multiline
                        autoComplete="shipping street-address"
                        color="secondary"
                        label="Address"
                        value={values.address}
                        inputProps={{
                            autoComplete: "shipping street-address",
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container justify="space-between" alignItems="center"
				  className={classes.formItem}>
                <Grid item xs={12} sm={6}>
                    <Box marginBottom="10px">
                        <Typography
                            variant="h5"
                            align={textAlignmentAdaptive}
                        >
							City
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        component={TextField}
                        fullWidth
                        type="text"
                        autoComplete="shipping address-level2"
                        name="city"
                        variant="outlined"
                        color="secondary"
                        label="City"
                        value={values.city}
                        inputProps={{
                            autoComplete: "shipping address-level2",
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container justify="space-between" alignItems="center"
				  className={classes.formItem}>
                <Grid item xs={12} sm={6}>
                    <Box marginBottom="10px">
                        <Typography
                            variant="h5"
                            align={textAlignmentAdaptive}
                        >
							State / Location
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        component={Location}
                        name="state"
                        label="State/Territory"
                        variant="outlined"
                        color="secondary"
                        fullWidth
                        type="text"
                        autoComplete="shipping address-level1"
                        value={values.state}
                        handleCustomChange={(value) => {
                            setFormikValues({
                                ...values,
                                state: value,
                            });
                        }}
                        placeholder="State"
                        inputProps={{
                            autoComplete: "shipping address-level1",
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container justify="space-between" alignItems="center"
				  className={classes.formItem}>
                <Grid item xs={12} sm={6}>
                    <Box marginBottom="10px">
                        <Typography
                            variant="h5"
                            align={textAlignmentAdaptive}
                        >
							Zip Code
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        component={TextField}
                        fullWidth
                        type="text"
                        autoComplete="shipping postal-code"
                        name="zip"
                        variant="outlined"
                        color="secondary"
                        label="Zip code"
                        value={values.zip}
                        inputProps={{
                            autoComplete: "shipping postal-code",
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container justify="space-between" alignItems="center"
				  className={classes.formItem}>
                <Grid item xs={12} sm={6}>
                    <Box marginBottom="10px">
                        <Typography
                            variant="h5"
                            align={textAlignmentAdaptive}
                        >
							Country
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        component={TextField}
                        fullWidth
                        type="text"
                        autoComplete="shipping country"
                        name="country"
                        variant="outlined"
                        color="secondary"
                        label="Country"
                        value={values.zip}
                        inputProps={{
                            autoComplete: "shipping country",
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default Address;
